import { useLang } from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import css from './index.module.scss';
import { ItfItem } from './type';

const B: React.FC = () => {
    const { t } = useLang('ces2026.B');

    const items: ItfItem[] = [
        {
            name: t('item1_name'),
            text: t('item1_text'),
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1765952211167/B1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952275267/B1_pad.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952210062/B1_m.webp',
            ],
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1765952211688/B1.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952212375/B1_pad.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952213959/B1_m.png',
            ],
        },
        {
            name: t('item2_name'),
            text: t('item2_text'),
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1765952210480/B2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952209585/B2_pad.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952210668/B2_m.webp',
            ],
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1765952212650/B2.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952212260/B2_pad.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952211869/B2_m.png',
            ],
        },
        {
            name: t('item3_name'),
            text: t('item3_text'),
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1765952210184/B3.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952209199/B3_pad.webp',
                'https://websiteoss.ecoflow.com/upload/image/1765952211468/B3_m.webp',
            ],
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1765952213176/B3.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952213798/B3_pad.png',
                'https://websiteoss.ecoflow.com/upload/image/1765952212937/B3_m.png',
            ],
        },
    ];

    return (
        <div id="ces-2026-B" className={`ces-2026-B ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-B'}>
            <div className="info">
                <h2 className="title">{t('title')}</h2>
            </div>
            <ul className="items">
                {items?.map((item: ItfItem, i: number) => (
                    <li className="item" key={i}>
                        <div className="item-img">
                            <EcoPicture jpg={item.jpg} webp={item.webp} alt={item.name} />
                        </div>
                        <div className="item-info">
                            <h3 className="item-name name">{item.name}</h3>
                            <p className="item-text text">{item.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default B;
